import { render, staticRenderFns } from "./clazzrule-view.vue?vue&type=template&id=2bf87b0d&scoped=true&"
import script from "./clazzrule-view.vue?vue&type=script&lang=js&"
export * from "./clazzrule-view.vue?vue&type=script&lang=js&"
import style0 from "./clazzrule-view.vue?vue&type=style&index=0&id=2bf87b0d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf87b0d",
  null
  
)

export default component.exports